(function () {
  if (window.__ccSearchAnalyticsInitialized) return;
  window.__ccSearchAnalyticsInitialized = true;

  var eventQueue = [];
  var publishAttempts = 0;
  var maxPublishAttempts = 20;

  function publish(name, data) {
    var payload = { name: name, data: data || {} };

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(payload.name, payload.data);
      return;
    }

    eventQueue.push(payload);
    scheduleQueueFlush();
  }

  function scheduleQueueFlush() {
    if (publishAttempts >= maxPublishAttempts || scheduleQueueFlush.timer) return;

    scheduleQueueFlush.timer = window.setTimeout(function () {
      scheduleQueueFlush.timer = null;
      publishAttempts += 1;

      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        while (eventQueue.length) {
          var queuedEvent = eventQueue.shift();
          Shopify.analytics.publish(queuedEvent.name, queuedEvent.data);
        }
        return;
      }

      if (eventQueue.length) scheduleQueueFlush();
    }, 250);
  }

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function sanitizeQuery(value) {
    var query = cleanText(value).toLowerCase().slice(0, 80);
    var looksLikeEmail = query.indexOf('@') !== -1;
    var looksLikeOrderNumber = /\b(?:\d[\s-]*){7,}\b/.test(query) || /\b(?:order|tracking)\s*#?\s*\d{4,}\b/.test(query);

    if (looksLikeEmail || looksLikeOrderNumber) {
      return { search_term: '[redacted]', query_redacted: true };
    }

    return { search_term: query, query_redacted: false };
  }

  function getInput(root) {
    return root.querySelector('.search__input');
  }

  function getQuery(root, link) {
    var input = getInput(root);
    var query = input ? input.value : '';

    if (!cleanText(query) && link) {
      try {
        query = new URL(link.href, window.location.origin).searchParams.get('q') || '';
      } catch (error) {
        query = '';
      }
    }

    return sanitizeQuery(query);
  }

  function getDestination(link) {
    try {
      return new URL(link.href, window.location.origin).pathname;
    } catch (error) {
      return '';
    }
  }

  function classifyResult(link) {
    if (link.closest('.cc-search-support')) return 'support';
    if (link.closest('.cc-search-product')) return 'product';
    if (link.closest('.cc-search-featured')) return 'featured_product';
    if (link.closest('.cc-search-discovery__links')) return 'popular_search';
    if (link.closest('.results--articles')) return 'article';
    if (link.closest('.results--collections')) return 'collection';
    if (link.closest('.results--queries')) return 'suggestion';
    if (link.closest('.results--pages')) return 'page';
    if (link.classList.contains('predictive-search__no-results')) return 'no_results_link';
    return 'other';
  }

  function getUniqueResultLinks(results) {
    var seen = {};
    var links = [];

    results.querySelectorAll('a[href]').forEach(function (link) {
      if (link.closest('[data-search-discovery]')) return;

      var key = getDestination(link) + '|' + cleanText(link.textContent);
      if (!key || seen[key]) return;

      seen[key] = true;
      links.push(link);
    });

    return links;
  }

  function trackResults(root) {
    var results = root.querySelector('#predictive-search');
    var resultContainer = results && results.querySelector('.predictive-search-results');
    if (!resultContainer) return;

    var queryData = getQuery(root);
    if (!queryData.search_term) return;

    var links = getUniqueResultLinks(resultContainer);
    var hasSupportResults = Boolean(resultContainer.querySelector('.cc-search-support'));
    var noResults = resultContainer.classList.contains('predictive-search-results--none') || links.length === 0;
    var signature = queryData.search_term + '|' + links.map(function (link) {
      return getDestination(link);
    }).sort().join(',');

    if (root.dataset.ccLastSearchSignature === signature) return;
    root.dataset.ccLastSearchSignature = signature;

    publish('carrycast:search_results_viewed', {
      search_term: queryData.search_term,
      query_redacted: queryData.query_redacted,
      results_count: links.length,
      no_results: noResults,
      intent_type: hasSupportResults ? 'support' : 'product_or_content'
    });
  }

  function initializeSearch(root) {
    if (root.dataset.ccSearchAnalyticsReady === 'true') return;
    root.dataset.ccSearchAnalyticsReady = 'true';

    var input = getInput(root);
    var form = root.querySelector('form[role="search"]');
    var results = root.querySelector('#predictive-search');
    var closeButton = root.querySelector('.btn--close-search');

    if (input) {
      input.addEventListener('focus', function () {
        if (root.dataset.ccSearchOpen === 'true') return;
        root.dataset.ccSearchOpen = 'true';
        publish('carrycast:search_opened', { search_context: root.dataset.context || 'unknown' });
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', function () {
        root.dataset.ccSearchOpen = 'false';
      });
    }

    if (form) {
      form.addEventListener('submit', function () {
        var queryData = getQuery(root);
        if (!queryData.search_term) return;

        publish('carrycast:search_submitted', {
          search_term: queryData.search_term,
          query_redacted: queryData.query_redacted
        });
      });
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      var viewAllButton = event.target.closest('.results__search-btn');

      if (!link && !viewAllButton) return;

      var queryData = getQuery(root, link);
      var resultType = viewAllButton ? 'view_all' : classifyResult(link);
      var resultTitle = cleanText(viewAllButton ? viewAllButton.textContent : link.textContent).slice(0, 120);

      publish('carrycast:search_result_clicked', {
        search_term: queryData.search_term,
        query_redacted: queryData.query_redacted,
        result_type: resultType,
        result_title: resultTitle,
        destination_path: link ? getDestination(link) : '/search'
      });
    });

    if (results) {
      var observer = new MutationObserver(function () {
        window.clearTimeout(root.ccSearchResultsTimer);
        root.ccSearchResultsTimer = window.setTimeout(function () {
          trackResults(root);
        }, 150);
      });

      observer.observe(results, { childList: true, subtree: true });
    }
  }

  function initializeAllSearches() {
    document.querySelectorAll('predictive-search').forEach(initializeSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAllSearches);
  } else {
    initializeAllSearches();
  }

  new MutationObserver(initializeAllSearches).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
